import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-overlay',
    imports: [FontAwesomeModule],
    template: `
    <div class="overlay-container">
      <div class="overlay-header">
        <button class="btn-close" (click)="close.emit()"></button>
      </div>
      <div class="overlay-body">
        @if (icon) {
        <fa-icon class="overlay-icon" [icon]="icon" [size]="iconSize" />
        }

        @if (message) {
        <h4 class="overlay-message">{{ message }}</h4>
        }
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;

      position: absolute;
      inset: 0;
      
      z-index: 1000;
    }

    :host(.error) { 
      .overlay-icon { color: var(--bs-danger); }
      .overlay-message { color: var(--bs-danger-text-emphasis); }
    }
    
    :host(.success) { 
      .overlay-icon { color: var(--bs-success); }
      .overlay-message { color: var(--bs-success-text-emphasis); }
    }
    
    :host(.warning) { 
      .overlay-icon { color: var(--bs-warning); }
      .overlay-message { color: var(--bs-warning-text-emphasis); }
    }

    .overlay-container {
      display: flex;  
      flex-direction: column;
      gap: 1rem;

      background: rgba(255, 255, 255, 0.75);
      border-top: 1px solid rgba(var(--bs-body-color-rgb), 0.1);
      border-bottom: 1px solid rgba(var(--bs-body-color-rgb), 0.1);

      backdrop-filter: blur(4px);
        
      padding: 1rem;
      height: 100%;
      width: 100%;

      .overlay-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .overlay-body {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;

        .overlay-message {
          text-align: center;
        }
      }
    }
  `]
})
export class OverlayComponent {

  //#region Input Properties
  @Input() icon?: IconProp
  @Input() iconSize: SizeProp = "4x";

  @Input() message?: string
  //#endregion

  //#region Output Properties
  @Output() close = new EventEmitter<void>();
  //#endregion

}
